import Model, { attr } from '@ember-data/model';

import type { ImageCropData, RecordData } from 'webapp-types';

import { DEFAULT_BG_IMAGE_OPACITY } from 'webapp/models/board';

export const DEFAULT_SLIDE_TITLE = 'My Slide';

export default class ReportSlideRecord extends Model {
	@attr('number') reportId!: number;
	@attr('number') order!: number;
	@attr('string') title!: string;
	@attr('string') image!: string;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	description!: RecordData.ReportSlide.Description;

	// seperate settings that will be serialized to 'settings' field
	// for all slide types except Board
	@attr('string') color!: string;
	@attr('number') themeId!: number;
	@attr('string') logo!: string;
	@attr('string') logoOriginal!: string; // logo url (original)
	@attr('object') logoCrop!: ImageCropData | null; // logo crop data
	@attr('string') bg!: string; // bg image url (cropped)
	@attr('string') bgOriginal!: string; // bg image url (original)
	@attr('object') bgCrop!: ImageCropData | null; // bg image crop data
	@attr('number', { defaultValue: DEFAULT_BG_IMAGE_OPACITY }) declare bgOpacity: number; // bg image opacity
}
